import { get, PropertyPath } from 'lodash-es';

import { Configuration, ReturnableValue } from './types';

type GetConfigByKey = (
    configuration?: Configuration,
) => <T = ReturnableValue>(path: PropertyPath, fallback?: T) => T | undefined;

export const getConfigByKey: GetConfigByKey =
    (configuration = {}) =>
    (path, fallback) => {
        return get(configuration, path, fallback);
    };
